<div class="page-content-wrapper">
  <div class="filter-forms-nav pages-title-nav p-0">
    <div class="container-fluid px-4">
      <div class="row align-items-center">
        <div class="sample-survey-details-title col-xs-12 col-sm-12 col-md-12 col-12 nav-colmn pl-0 ">
          <ul class="page-name-div sample-survey-name-list d-flex align-items-center">
            <a class="left-arrow" routerLink="/dashboard/samples/survey">
              <span class="material-symbols-outlined purple-text pt-1 ">chevron_left</span>
            </a>
            <b class="pl-3">{{ 'Survey Details' | translate}}</b>
            <span class="ml-auto d-flex">
              <button class="btn btn-primary generate-report-btn"
                [disabled]="isLoading || isGeneratingReport" (click)="openReportGenerationPopup()">
                <i class="fas" [class.fa-spinner]="isGeneratingReport"
                  [class.fa-spin]="isGeneratingReport"
                [class.fa-file-pdf]="!isGeneratingReport"></i>
                {{ (isGeneratingReport ? 'Loading...' : 'Generate Report') | translate }}
              </button>
              <span class="my-auto" *objectHasPermission="permissionObject; action: editAction">
                <button type="button" class="edit-icon-button" [disabled]="!canEdit"
                  [title]="editTooltip"
                  [attr.aria-label]="editTooltip"
                  [class.disabled-button]="!canEdit"
                  (click)="openSampleSurveyDialog()">
                  <i class="edit-icon material-icons" aria-hidden="true">edit</i>
                </button>
              </span>
            </span>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="page-content-inner-wrap card-style-sec sample-survey-details-page-wrap custom-scrollbar">
    <div class="container-fluid">
      <div class="row pt-2">
        <div class="col-md-8 row">
          <div class="col-md-12 two-col">
            <h3 class="section-title">
              <img src="assets/images/sample-overview.svg" class="mr-1">
              {{ 'Survey Details' | translate}}
              <div class="absolute-right">
                @if (sampleSurveyDetails) {
                  <mat-form-field appearance="fill" class="sample-survey-select"
                    [matTooltip]="!canChangeStatus ? ('No permission to update' | translate) : ''">
                    <mat-select [(value)]="sampleSurveyDetails.surveyStatus"
                      panelClass="sample-survey-dropdown-panel"
                      [disabled]="!canChangeStatus"
                      (selectionChange)="onSurveyClosedChange()">
                      <mat-select-trigger>
                        @for (option of surveyStatusOptions; track trackByIndex($index)) {
                          @if (option.value === sampleSurveyDetails.surveyStatus) {
                            <span
                              class="survey-badge" [ngClass]="option.cssClass">
                              {{ option.labelKey | translate }}
                            </span>
                          }
                        }
                      </mat-select-trigger>
                      @for (option of surveyStatusOptions; track trackByIndex($index)) {
                        <mat-option class="sample-survey-dropdown-options"
                          [value]="option.value">
                          <span class="survey-badge" [ngClass]="option.cssClass">
                            {{ option.labelKey | translate }}
                          </span>
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
            </h3>
            <ng-container *ngTemplateOutlet="displaySection; context: { fields: SampleSurveyFields }">
            </ng-container>
          </div>
        </div>
        @if (attachedFiles.length || attachedReports.length) {
          <div class="col-md-4 row">
            @if (attachedFiles.length) {
              <div class="col-md-12 two-col">
                <h3 class="section-title">
                  <img src="assets/images/link.svg" class="mr-1">
                  {{ 'Attachments' | translate}}
                </h3>
                <div class="section">
                  <div class="row">
                    @for (attachment of attachedFiles; track trackById($index, attachment)) {
                      <div class="col-md-6">
                        <div class="attachment-item">
                          <span><img [src]="attachment.imgSrc" class="mr-2">
                          {{ attachment.name }}</span>
                          <button mat-icon-button color="primary"
                            (click)="downloadAttachment(attachment)">
                            <img src="assets/images/download.svg">
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            @if (attachedReports.length) {
              <div class="col-md-12 two-col">
                <h3 class="section-title">
                  <img src="assets/images/link.svg" class="mr-1">
                  {{ 'Reports' | translate}}
                </h3>
                <div class="section">
                  <div class="row">
                    @for (attachment of attachedReports; track trackById($index, attachment)) {
                      <div class="col-md-12">
                        <div class="attachment-item">
                          <span class="file-name"><img [src]="attachment.imgSrc" class="mr-2">
                          {{ attachment.name }}</span>
                          @if (attachment.emailStatus != null) {
                            <span class="email-status">
                              <i class="fa fa-envelope mx-1"></i>
                              {{emailStatusEnum[attachment.emailStatus] | translate}}
                              @if (attachment?.emailSentDate && attachment.emailStatus == emailStatusEnum.Sent) {
                                <span class="email-date">
                                  {{ attachment.emailSentDate | dateFormat }}
                                </span>
                              }
                            </span>
                          }
                          <button mat-icon-button color="primary"
                            (click)="downloadAttachment(attachment)">
                            <img src="assets/images/download.svg">
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>

<ng-template #displaySection let-fields="fields">
  <div class="section">
    <div class="field-container">
      @for (field of fields; track trackByIndex($index)) {
        <div class="field" [ngClass]="{ 'cursor-pointer': $safeNavigationMigration(field?.isClickable) }"
          (click)="field?.isClickable ? onClick(field): null">
          <div class="field-label">{{ field.label }}</div>
          <div class="field-value">{{ field.value || '-' }}</div>
        </div>
      }
    </div>
  </div>
</ng-template>

@if (showReportGenerationPopup) {
  <app-report-generation-popup
    [entity]="{survey: sampleSurveyDetails, samples: samples}" [entityType]="'SampleSurvey'"
    [organizationLevels]="organizationsList" [entityId]="$safeNavigationMigration(sampleSurveyDetails?.id)"
    [isVisible]="showReportGenerationPopup" [isWaitingForData]="isGeneratingReport"
    [columnDetails]="columnDetails"
  (close)="closeReportGenerationPopup()" (pdfGenerated)="onPdfGenerated($event)"></app-report-generation-popup>
}
